import { gql } from 'graphql-tag';

export const GET_FIELD_VALUES = gql`
  query Id617a3618918f033969176beaba4dc5f3($companyId: ID!) {
    __typename
  }
`;
